module.exports = __webpack_public_path__ + "img/medio_lock.ee12c6c5.svg";